import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield, Lock, Eye } from 'lucide-react';

export default function PrivacyPage() {
  return (
    <div className="@container/privacy max-w-[1800px] w-full mx-auto px-3 py-4 @[740px]/privacy:px-4 @[740px]/privacy:py-5 @[1100px]/privacy:px-6 @[1100px]/privacy:py-6 space-y-4 @[740px]/privacy:space-y-5 @[1100px]/privacy:space-y-6">
      <div className="space-y-3 @[740px]/privacy:space-y-4">
        <h1 className="text-xl @[740px]/privacy:text-2xl @[1100px]/privacy:text-3xl font-bold">Privacy Policy</h1>
        <p className="text-muted-foreground text-lg">
          Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>
      </div>

      <Card>
        <CardHeader>
          <Shield className="h-8 w-8 text-primary mb-2" />
          <CardTitle>Your Privacy Matters</CardTitle>
          <CardDescription>
            We are committed to protecting your personal information
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-3">Information We Collect</h2>
            <p className="text-sm text-muted-foreground mb-2">
              We collect information that you provide directly to us, including:
            </p>
            <ul className="text-sm text-muted-foreground space-y-1 list-disc list-inside ml-4">
              <li>Name and email address when you create an account</li>
              <li>Profile information you choose to provide</li>
              <li>Usage data and preferences when using our platform</li>
              <li>Communication records when you contact us</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">How We Use Your Information</h2>
            <p className="text-sm text-muted-foreground mb-2">
              We use the information we collect to:
            </p>
            <ul className="text-sm text-muted-foreground space-y-1 list-disc list-inside ml-4">
              <li>Provide and maintain our streaming services</li>
              <li>Authenticate your identity and manage your account</li>
              <li>Send you important updates and notifications</li>
              <li>Improve our platform and user experience</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Data Security</h2>
            <div className="flex items-start gap-3">
              <Lock className="h-5 w-5 text-primary mt-0.5" />
              <div>
                <p className="text-sm text-muted-foreground">
                  We implement industry-standard security measures to protect your personal information. 
                  This includes encryption, secure authentication, and regular security audits. 
                  However, no method of transmission over the internet is 100% secure.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Your Rights</h2>
            <p className="text-sm text-muted-foreground mb-2">
              You have the right to:
            </p>
            <ul className="text-sm text-muted-foreground space-y-1 list-disc list-inside ml-4">
              <li>Access and update your personal information</li>
              <li>Request deletion of your account and data</li>
              <li>Opt-out of certain communications</li>
              <li>Request a copy of your data</li>
            </ul>
            <p className="text-sm text-muted-foreground mt-3">
              To request account deletion, please visit our{' '}
              <a href="/account-deletion-request" className="text-primary hover:underline">
                Account Deletion Request page
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Contact Us</h2>
            <div className="flex items-start gap-3">
              <Eye className="h-5 w-5 text-primary mt-0.5" />
              <div>
                <p className="text-sm text-muted-foreground">
                  If you have questions about this Privacy Policy or wish to exercise your rights, 
                  please contact us at{' '}
                  <a href="mailto:streaming@dominioncity.org.za" className="text-primary hover:underline">
                    streaming@dominioncity.org.za
                  </a>
                </p>
              </div>
            </div>
          </section>
        </CardContent>
      </Card>
    </div>
  );
}
